import {mapGetters, mapMutations, mapActions} from "vuex";

import {required, minLength} from 'vuelidate/lib/validators'
import {TheMask} from 'vue-the-mask'
export default {
    name: 'fast-order',
    components: {
        TheMask,
    },
    data() {
        return {
            submitted: false,
            payload: {
                type: "quick",
                user_name: '',
                user_phone: '',
                product: '',
            }
        }
    },
    validations: {
        payload: {
            user_name: {required, minLength: minLength(2)},
            user_phone: {required, minLength: minLength(11)},
        }
    },
    methods: {
        ...mapMutations({
            changeShowThanksOrder: 'order/THANKS_ORDER',
            changeShowFastOrder: 'order/FAST_ORDER'
        }),
        sendOrder() {

            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.payload.product = this.productData.id
                this.fastBay(this.payload).then(() => {
                    this.changeShowThanksOrder(true)
                    this.changeShowFastOrder(false)
                })
            }
        },
        ...mapActions({
            fastBay: 'order/FAST_BUY',
        }),


    },
    computed: {
        ...mapGetters({
            productData: 'card/productData',
            userInfo: 'userData/userInfo'
        }),
    }
}
